import { makeRequest } from 'utils/requestLogger';

export default (id, courses) =>
  makeRequest('post', `/api/courses/${id}/import-feedback-live`, { courses });



// WEBPACK FOOTER //
// ./src/app/services/courses/importFeedbackLive.js